import $ from "jquery-import";
import "jquery-ui";
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/ui/widgets/mouse";
import "jquery-ui/ui/widgets/autocomplete";
import "jquery-ui/ui/widgets/menu";
import "jquery-ui/ui/unique-id";
import "jquery-ui/ui/keycode";
import "jquery-ui/ui/position";
import utils from "utils";

import "jquery-ui/dist/themes/base/jquery-ui.css";
import "jquery-ui/themes/base/autocomplete.css";
import "jquery-ui/themes/base/menu.css";

window.$ = window.jQuery = $;

// utils.requireCSS("jquery-ui");
// utils.requireCSS("jquery-ui/themes/base/jquery-ui");

export default $;
